"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PixelmonDebugPanel;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _defaultPanelStyle = _interopRequireWildcard(require("./defaultPanelStyle"));
var _PixelRecordView = _interopRequireDefault(require("./PixelRecordView"));
var _PixelDebugRow = _interopRequireDefault(require("./PixelDebugRow"));
var _PixelmonPropTypes = _interopRequireDefault(require("./PixelmonPropTypes"));
function PixelmonDebugPanel(_ref) {
  var _ref$registeredPixels = _ref.registeredPixels,
    registeredPixels = _ref$registeredPixels === void 0 ? [] : _ref$registeredPixels,
    _ref$firedPixels = _ref.firedPixels,
    firedPixels = _ref$firedPixels === void 0 ? [] : _ref$firedPixels,
    _ref$projectId = _ref.projectId,
    projectId = _ref$projectId === void 0 ? '' : _ref$projectId,
    _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? '' : _ref$appId,
    _ref$weSdkVersion = _ref.weSdkVersion,
    weSdkVersion = _ref$weSdkVersion === void 0 ? '' : _ref$weSdkVersion;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    panelCollapsed = _useState2[0],
    setPanelCollapsed = _useState2[1];
  var style = _defaultPanelStyle["default"];
  if (panelCollapsed) {
    style = Object.assign({}, _defaultPanelStyle["default"], {
      height: _defaultPanelStyle.COLLAPSED_HEIGHT
    });
  }

  // Set by a click on one of the rows in the Fired Pixels sections
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    pixelRecordToView = _useState4[0],
    setPixelRecordToView = _useState4[1];

  // If we're in "view single record" mode, just show that single PixelRecordView!
  if (pixelRecordToView) {
    return /*#__PURE__*/_react["default"].createElement(_PixelRecordView["default"], {
      pixelRecord: pixelRecordToView,
      onExitClick: function onExitClick() {
        return setPixelRecordToView(null);
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pixelmon-debug",
    style: style
  }, /*#__PURE__*/_react["default"].createElement("button", {
    id: "collapse-pixelmon-debug",
    onClick: function onClick() {
      return setPanelCollapsed(!panelCollapsed);
    }
  }, panelCollapsed ? 'Expand' : 'Collapse'), /*#__PURE__*/_react["default"].createElement("div", {
    id: "pixelmon-debug-panel-header",
    style: {
      position: 'absolute',
      top: '0px',
      width: '75%',
      "float": 'right',
      right: '0px',
      textAlign: 'right',
      fontSize: '0.8em'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, "projectId:"), " ", projectId, " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, "appId:"), " ", appId, " ", /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement("h2", {
    style: {
      textAlign: 'center'
    }
  }, "Pixelmon Debugger"), /*#__PURE__*/_react["default"].createElement("h3", null, "Registered Pixels"), /*#__PURE__*/_react["default"].createElement("table", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "name"), /*#__PURE__*/_react["default"].createElement("th", null, "event"))), /*#__PURE__*/_react["default"].createElement("tbody", null, registeredPixels.map(function (pixelConfig, index) {
    return /*#__PURE__*/_react["default"].createElement(_PixelDebugRow["default"], {
      key: "registered-pixel-".concat(index, "-").concat(pixelConfig.id),
      pixelConfig: pixelConfig
    });
  }))), /*#__PURE__*/_react["default"].createElement("h3", null, "Fired Pixels"), /*#__PURE__*/_react["default"].createElement("table", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "name"), /*#__PURE__*/_react["default"].createElement("th", null, "event"))), /*#__PURE__*/_react["default"].createElement("tbody", null, firedPixels.map(function (pixelRecord, index) {
    var onClick = function onClick() {
      setPixelRecordToView(pixelRecord);
    };
    return /*#__PURE__*/_react["default"].createElement(_PixelDebugRow["default"], {
      key: "fired-pixel-".concat(index, "-").concat(pixelRecord.pixelConfig.id),
      pixelConfig: pixelRecord.pixelConfig,
      onClick: onClick
    });
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    id: "pixelmon-debug-panel-footer",
    style: {
      position: 'absolute',
      bottom: '0px',
      width: '100%',
      "float": 'right',
      right: '0px',
      textAlign: 'right',
      fontSize: '0.8em'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, "we-sdk ", weSdkVersion, " "), " ", /*#__PURE__*/_react["default"].createElement("br", null)));
}